export { default as NewEncountersVolumeCell } from './NewEncountersVolumeCell';
